import { render } from "./DonationReceived.vue?vue&type=template&id=06b5dcca&scoped=true&lang=pug"
import script from "./DonationReceived.vue?vue&type=script&setup=true&lang=js"
export * from "./DonationReceived.vue?vue&type=script&setup=true&lang=js"

import "./DonationReceived.vue?vue&type=style&index=0&id=06b5dcca&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b5dcca"]])

export default __exports__